import styles from './Product.module.css'
import icon from './assets/icon.svg';

import { generateThumbnail } from '../../Helpers/ThumbHelper';


export default function Product({id,specifier,focus,size,title,description,onSelect,favorites,onFavorite,isActive,series, addToBoard},) {
    const isFavorite = favorites && favorites[id];
    const isIframed = window.self !== window.top;
    return(
            <li className={`${styles.product} ${isActive?styles.active:''}`} data-id={id} onClick={() => {onSelect(id)}} data-size={description}>

                {isFavorite ? (
                    <div
                        className={`${styles.favorite} ${styles.favoriteActive}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            onFavorite(id, isFavorite);
                        }}
                    >
                        <p>&#9734;</p>
                    </div>
                ) : (
                    <div
                        className={`${styles.favorite}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            onFavorite(id, isFavorite);
                        }}
                    >
                        <p>&#9734;</p>
                    </div>
                )}

                <div className={styles.imgWrapper}>
                    <img loading='lazy' src={generateThumbnail(id, specifier, size, focus, series)} alt={`Product - ${id}`} />
                    <div className={styles.activeContent}>
                        <img src={icon} className={styles.selectedImg} width="96" height="69" alt="product thumbnail"/>
                    </div>
                    
                </div>
                <div className={styles.productInfo}>
                    <div className={styles.title}>{title}</div>
                    <div className={styles.description}>{description}</div>
                </div>
            </li>
    );
}